module.exports = __webpack_public_path__ + "img/icon2.9006fc08.svg";